import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import OrganizationSetPage from '@/features/reports/components/pages/OrganizationSetPage'

export const Route = createFileRoute('/app/organizations/$organizationId/reports/sets/$setId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { setId } = Route.useParams()
  const { organization } = useOrganization()
  const { userCanViewAssessments } = useReports()

  return (
    <OrganizationSetPage
      organization={organization}
      setId={Number(setId)}
      userCanViewAssessments={userCanViewAssessments}
    />
  )
}
